export default __webpack_public_path__ + "static/media/purple_front.4dce41aa.png";